import { useEffect, useState } from 'react';
import { debounce } from 'utils/common';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

export default function useUniformStockFilter(pageSettings, setPageSettings) {
    const [searchParams] = useSearchParams();
    const {
        userData, userDataLoading,
        uniformSizes, uniformSizesLoading
    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false);
    const [filters, setFilters] = useState([
        {
            key: "search",
            label: "Search term",
            value: searchParams.get("search") || ""
        },
        {
            key: "uniform",
            label: "Uniform",
            value: searchParams.get("uniform") || ""
        },
        {
            key: "size",
            label: "Size",
            value: searchParams.get("size") || ""
        },
        {
            key: "created_by",
            label: "Created By",
            value: searchParams.get("created_by") || ""
        },
        {
            key: "stock_date",
            label: "Stock Date",
            value: searchParams.get("stock_date") || ""
        }
    ]);

    useEffect(() => {
        if (!userDataLoading && !uniformSizesLoading) {
            let _filters = [
                {
                    key: "search",
                    label: "Search term",
                    value: searchParams.get("search") || ""
                },
                {
                    key: "uniform",
                    label: "Uniform",
                    value: searchParams.get("uniform") || ""
                },
                {
                    key: "size",
                    label: "Size",
                    value: searchParams.get("size") || ""
                },
                {
                    key: "created_by",
                    label: "Created By",
                    value: searchParams.get("created_by") || ""
                },
                {
                    key: "stock_date",
                    label: "Stock Date",
                    value: searchParams.get("stock_date") || ""
                }
            ];
            setFilters(_filters);
        }
    }, [userData, uniformSizes, userDataLoading, uniformSizesLoading, searchParams]);

    const handleInputChange = debounce((data, key, make_call = false) => {
        let _filters = [...filters];
        let selectedFilter = _filters.find(item => item.key === key);
        selectedFilter['label'] = key;
        selectedFilter['value'] = data;
        setFilters(_filters);

        if (make_call) {
            setPageSettings({
                ...pageSettings,
                page: 1,
                filters: _filters
            });
        }
    }, 1000);

    const handleFilterChange = (data, key, make_call = false) => {
        let _filters = [...filters];
        let selectedFilter = _filters.find(item => item.key === key);

        selectedFilter['label'] = data?.label || "";
        selectedFilter['value'] = data?.value || "";
        setFilters(_filters);

        if (make_call) {
            setPageSettings({
                ...pageSettings,
                page: 1,
                filters: _filters
            });
        }
    };

    const handleDateChange = (data, key, make_call = false) => {
        let _filters = [...filters];
        let selectedFilter = _filters.find(item => item.key === key);

        selectedFilter['label'] = key;
        selectedFilter['value'] = data || "";
        setFilters(_filters);

        if (make_call) {
            setPageSettings({
                ...pageSettings,
                page: 1,
                filters: _filters
            });
        }
    };

    return {
        handleFilterChange,
        filters,
        filterLoading,
        setFilterLoading,
        handleInputChange,
        handleDateChange
    };
}

